module.exports = __webpack_public_path__ + "static/media/logo_icon.f6145406.svg";